var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 111,
    viewBox: "0 0 112 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9818 1.18196C60.3585 -0.54683 62.8962 -0.301644 62.9349 1.46728L63.2582 16.3068C63.6757 35.4686 77.169 51.8481 95.8963 55.9263L110.399 59.0846C112.128 59.4613 111.883 61.999 110.114 62.0377L95.2746 62.361C76.1129 62.7785 59.7334 76.2718 55.6552 94.9991L52.4969 109.502C52.1202 111.231 49.5825 110.986 49.5438 109.217L49.2205 94.3774C48.803 75.2158 35.3097 58.8363 16.5822 54.758L2.0791 51.5997C0.350311 51.2231 0.595497 48.6853 2.36442 48.6466L17.2039 48.3233C36.3657 47.9058 52.7453 34.4125 56.8235 15.6851L59.9818 1.18196Z",
    fill: "#E35B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.558c9d62ad29b03c0010388a39dd66a4.svg";
export { ForwardRef as ReactComponent };